export const pages = {
	'linkOutKR': { id: 'linkOutKR', page: 'text', getter: () => import(/* webpackChunkName: 'text' */ 'components/bolt/text/text') }
};
export const sections = [

];
